/**
 * カード番号からブランドを判定
 * @param {string} cardNumber - カード番号（フォーマット済み or 未フォーマット）
 * @returns {string} ブランド名（'VISA', 'MASTER', 'JCB', 'AMEX', 'DINERS', 'DISCOVER', 'UNKNOWN'）
 */
export const detectCardBrand = (cardNumber) => {
  // ハイフンとスペースを除去
  const cleanNumber = cardNumber.replace(/[\s-]/g, '');
  
  // 各ブランドの判定ロジック
  if (/^4/.test(cleanNumber)) {
    return 'VISA';
  }
  
  if (/^5[1-5]/.test(cleanNumber) || /^2[2-7]/.test(cleanNumber)) {
    return 'MASTER';
  }
  
  if (/^35/.test(cleanNumber)) {
    return 'JCB';
  }
  
  if (/^3[47]/.test(cleanNumber)) {
    return 'AMEX';
  }
  
  if (/^3(0[0-5]|[68])/.test(cleanNumber)) {
    return 'DINERS';
  }
  
  if (/^6(011|5|4[4-9]|22)/.test(cleanNumber)) {
    return 'DISCOVER';
  }
  
  return 'UNKNOWN';
};

/**
 * ブランド名から表示用の名称を取得
 * @param {string} brand - ブランドコード
 * @returns {string} 表示用ブランド名
 */
export const getCardBrandDisplayName = (brand) => {
  const brandNames = {
    'VISA': 'Visa',
    'MASTER': 'Mastercard',
    'JCB': 'JCB',
    'AMEX': 'American Express',
    'DINERS': 'Diners Club',
    'DISCOVER': 'Discover',
    'UNKNOWN': 'クレジットカード'
  };
  
  return brandNames[brand] || brandNames.UNKNOWN;
};